export default __webpack_public_path__ + "static/media/classic_preparation.ed3361c7.jpg";